'use client';
import { DeepSignal } from 'deepsignal/react';
import React from 'react';
import { SearchFormStore } from '../types';

export const SearchFormContext = React.createContext<DeepSignal<SearchFormStore> | null>(null);
